import angular, { ILogService, ITimeoutService } from 'angular'
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos'
import { IGrupoDoc } from 'src/_candidato/data/tiposStore'
import { NotificacionService } from 'src/_panel/module/uni-base/services/NotifService'
import { IEstadoCvStoreItem, IModelNotificacionDoc } from 'src/model/candidato-api'
import { ReglaNotifDoc } from '../panel-doc-notifications/panel-doc-notifications.component'

class ReglaNotifDocComponentCtrl {
  regla!: ReglaNotifDoc

  estadosList: IEstadoCvStoreItem[]
  tiposDocGruposList: IGrupoDoc[]

  dirty = false

  edit: {
    estado: string | null
    doc: string | null
    mails: string | null
    activanotif: boolean
    todosdocs: boolean
  } = {
    estado: null,
    doc: null,
    mails: null,
    activanotif: false,
    todosdocs: false,
  }

  constructor(
    private $element: JQLite,
    private $timeout: ITimeoutService,
    private $log: ILogService,
    private NotifService: NotificacionService,
    private AccesoDatos: AccesoDatos
  ) {}

  $onInit(): void {
    this.$log.info('[ReglaNotifDocComponentCtrl] onInit')

    this.estadosList = this.regla.estadosList
    this.tiposDocGruposList = this.regla.tiposDocGruposList

    this.edit.estado = this.regla.rule.estado
    this.edit.doc = this.regla.rule.tipodoc

    this.edit.mails = this.regla.mailsEnvioString()
    this.edit.activanotif = this.regla.notifActiva()
  }

  $postLink() {
    // this.$timeout(() => (this.$element.find('select') as any).formSelect(), 100)

    this.$timeout(() => {
      let textarea = this.$element.find('.materialize-textarea')

      if (textarea && textarea[0]) M.textareaAutoResize(textarea)
    }, 200)
  }

  update() {
    let rule = Object.assign({}, this.regla.rule) as IModelNotificacionDoc

    rule.todosdocs = this.edit.todosdocs
    rule.tipodoc = this.edit.doc
    rule.estado = this.edit.estado
    rule.activanotif = this.edit.activanotif
    rule.mail = this.edit.mails

    this.AccesoDatos.Documentacion_CLIENT.actualizaReglaNotifDocDoc(rule).then((ruleResponse) => {
      this.regla.actualiza(ruleResponse)

      this.dirty = false
    })
  }
}

angular.module('candidato').component('reglaNotifDoc', {
  bindings: {
    regla: '<',
  },
  controller: ReglaNotifDocComponentCtrl,
  // templateUrl: "regla-notif-doc.component.html",
  template: require('./regla-notif-doc.component.html'),
})
